<script lang="ts">
  enum TitleType {
    H1 = 'h1',
    H2 = 'h2',
    H3 = 'h3',
    H4 = 'h4',
    H5 = 'h5',
    H6 = 'h6',
  }

  interface Props {
    type?: TitleType | string;
    name?: string;
    children?: import('svelte').Snippet;
  }

  let { type = '', name = '', children }: Props = $props();
</script>

{#if type === TitleType.H2}
  <h2 data-cy={name} class="comp-title">{@render children?.()}</h2>
{:else if type === TitleType.H3}
  <h3 data-cy={name} class="comp-title">{@render children?.()}</h3>
{:else if type === TitleType.H4}
  <h4 data-cy={name} class="comp-title">{@render children?.()}</h4>
{:else}
  <h1 data-cy={name} class="comp-title">{@render children?.()}</h1>
{/if}

<style>
  .comp-title {
    color: var(--black);
  }
  h1.comp-title {
    font-size: 28px;
    line-height: 34px;
    font-weight: 700;
  }
  h2.comp-title {
    font-weight: bold;
    font-size: 22px;
    line-height: 26px;
  }
  h3.comp-title {
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
  }
  h4.comp-title {
    font-weight: bold;
    font-size: 14px;
    line-height: 22px;
  }
</style>
